import { Link } from 'react-router-dom'

import cn from './DictionaryPageHeader.module.scss'

type DictionaryPageHeaderProps = {
  title: string
  activePage: 'categories' | 'characteristics'
  actionButton?: React.ReactNode
  showSwitcher?: boolean
}

function DictionaryPageHeader(props: DictionaryPageHeaderProps) {
  const { title, activePage, actionButton, showSwitcher = true } = props

  return (
    <div className={cn.header}>
      <h1 className={cn.title}>{title}</h1>
      <div className={cn.actions}>
        {showSwitcher && (
          <div className={cn.switcher}>
            <Link
              to="/categories-catalog"
              className={[
                cn.switchLink,
                activePage === 'categories' ? cn.switchLinkActive : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              Категории
            </Link>
            <Link
              to="/characteristics-catalog"
              className={[
                cn.switchLink,
                activePage === 'characteristics' ? cn.switchLinkActive : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              Характеристики
            </Link>
          </div>
        )}
        {actionButton}
      </div>
    </div>
  )
}

export default DictionaryPageHeader
